import { Component, Inject, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { InterpretationService } from '../../interpretation.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-system-serial-number',
  templateUrl: './edit-system-serial-number.component.html',
  styleUrls: ['./edit-system-serial-number.component.scss']
})
export class EditSystemSerialNumberComponent implements OnInit {
  SerialNumber:string;
  systemId:number;
  constructor(public dialogRef: MatDialogRef<EditSystemSerialNumberComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any, private _notify: NotificationsService,
    private _interp: InterpretationService) { }

  ngOnInit() {
    this.SerialNumber = this._data.SerialNumber;
    this.systemId = this._data.systemId;
  }

  onNoClick(){
    this.dialogRef.close(false);
  }

  UpdateSerialNumber(){
    this._interp.UpdateSystemSerialNumber( this.SerialNumber, this.systemId).subscribe(res=>{
      if(res.m_Item1==true){
        this.dialogRef.close(true);
      }else{ 
        this._notify.error('Operation failed!', 'That system serial number already exists! Please enter a valid serial number.');
        
      }
    })
  }

}
